import Swiper from 'swiper'

const sliders = document.getElementsByClassName('swiper-container')

for (let i = 0; i < sliders.length; i++) {
    const slides = sliders[i].querySelectorAll('.slider__slide')

    const Slider = new Swiper(sliders[i], {
        loop: true,
        spaceBetween: 10,
        simulateTouch: false,
        autoHeight: true,
        pagination: {
            el: sliders[i].parentElement
                .querySelector('.swiper-pagination'),
            type: 'fraction'
        },
        navigation: {
            nextEl: sliders[i].parentElement
                .querySelector('.swiper-button-next'),
            prevEl: sliders[i].parentElement
                .querySelector('.swiper-button-prev')
        }
    })

    if (slides.length === 1) {
        Slider.destroy()
        sliders[i].classList
            .add('swiper-disabled')
    }
}
